export const MobileMenuSearchIcon: React.FC<React.SVGAttributes<{}>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 20 18"
      {...props}
    >
      <path
        fill="curentColor"
        d="M16.196 11.253a5.28 5.28 0 0 0 1.137-3.254A5.334 5.334 0 1 0 12 13.333a5.28 5.28 0 0 0 3.253-1.138l3.61 3.609a.666.666 0 0 0 .942-.943l-3.61-3.608ZM8 7.999a4 4 0 1 1 8 0 4 4 0 0 1-8 0ZM19.333 0H.667a.667.667 0 1 0 0 1.333h18.666a.667.667 0 1 0 0-1.333ZM.667 9.333h4a.667.667 0 1 0 0-1.333h-4a.667.667 0 0 0 0 1.333ZM.667 13.333h4a.667.667 0 1 0 0-1.333h-4a.666.666 0 1 0 0 1.333ZM.667 17.333h14.666a.667.667 0 1 0 0-1.333H.667a.666.666 0 1 0 0 1.333ZM.667 5.333h4a.667.667 0 1 0 0-1.333h-4a.667.667 0 0 0 0 1.333Z"
      />
    </svg>
  );
};
